import { theme as appTheme } from '#app/theme/theme.js';
import { type ThemeWithMultiColumnLayoutMode } from '#app/types/multiColumnLayoutMode.js';
import { SkeletonLoader } from './SkeletonLoader.js';
import { type SkeletonLoaderProps } from './types.js';
import { forwardRef, type Ref } from 'react';
import { css, styled } from 'styled-components';

/**
 * Note: This component relies on the ThemeWithMultiColumnLayoutMode in the WorkTab
 * - @imbhargav5.
 * Putting this file along with other Skeleton components here and awaiting team feedback on the
 * right place to put it.
 */
const Wrapper = styled.div<{
  isLoading?: boolean;
  theme: ThemeWithMultiColumnLayoutMode;
}>`
  ${({ isLoading = false, theme }) => css`
    background: ${theme.colorsV2.white};
    border-radius: 20px;
    opacity: ${isLoading ? 1 : 0};
    height: ${isLoading ? 'auto' : '0px'};
    max-width: 100%;
    > div > div {
      // No margin on ItemLoader
      margin: 0px;
    }
    ${theme.multiColumnLayoutMode.mediaQueries.twoColumn} {
      max-width: 680px;
    }
    ${theme.multiColumnLayoutMode.mediaQueries.threeColumn} {
      max-width: 100%;
    }
    svg {
      width: 100%;
    }
  `}
`;

export const WorkOpportunitySkeleton = forwardRef(
  (props: SkeletonLoaderProps, ref: Ref<HTMLDivElement>) => (
    <Wrapper isLoading={props.isLoading}>
      <SkeletonLoader
        colorBase={appTheme.colorsV2.white}
        gradientColor1={appTheme.colorsV2.gray05}
        gradientColor2={appTheme.colorsV2.gray30}
        height={183}
        ref={ref}
        width={680}
        {...props}
      >
        <circle
          cx="64"
          cy="64"
          fill="#F7F7F7"
          r="32"
        />
        <rect
          fill="#F7F7F7"
          height="16"
          rx="8"
          width="138"
          x="112"
          y="44"
        />
        <rect
          fill="#F7F7F7"
          height="16"
          rx="8"
          width="92"
          x="112"
          y="68"
        />
        <rect
          fill="#F7F7F7"
          height="16"
          rx="8"
          width="294"
          x="32"
          y="112"
        />
        <rect
          fill="#F7F7F7"
          height="16"
          rx="8"
          width="155"
          x="32"
          y="136"
        />
      </SkeletonLoader>
    </Wrapper>
  ),
);
